// extracted by mini-css-extract-plugin
export default {"main":"Projects_main__JxIdu","projectLg":"Projects_projectLg__F0bZy","projectSm":"Projects_projectSm__JsrJS"};